export default function HeroSection() {
  const handleExplore = () => {
    const el = document.querySelector('#collections');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleStore = () => {
    const el = document.querySelector('#location');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full h-[100vh] min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=elegant%20minimalist%20fashion%20editorial%20photo%2C%20beautiful%20asian%20woman%20wearing%20luxurious%20cream%20beige%20outfit%2C%20soft%20warm%20natural%20light%2C%20clean%20white%20studio%20background%20with%20subtle%20warm%20tones%2C%20high-end%20fashion%20photography%2C%20sophisticated%20style%2C%20soft%20bokeh%2C%20warm%20gold%20accents%2C%20premium%20quality%20clothing%2C%20serene%20and%20refined%20atmosphere%2C%20fashion%20magazine%20spread&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
        alt="品牌形象大圖"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Announcement Bar */}
      <div className="absolute top-20 left-1/2 -translate-x-1/2 whitespace-nowrap">
        <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/30 text-white text-sm font-sans-body px-4 py-1.5 rounded-full tracking-wider">
          <span className="w-1.5 h-1.5 flex items-center justify-center">
            <span className="block w-1.5 h-1.5 rounded-full bg-gold-300"></span>
          </span>
          台中門市全面換季特賣，折扣高達 7 折
        </span>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 text-center px-6 w-full">
        <p className="font-sans-body text-[1.1875rem] text-white/80 tracking-widest mb-4 font-light">
          TAICHUNG · OUTLET · FASHION
        </p>

        <h1 className="font-serif-title text-[2rem] md:text-[2.75rem] text-white font-semibold leading-[1.3] mb-5">
          經典品牌，驚喜價格
        </h1>

        <p className="font-sans-body text-[1.1875rem] text-white/85 leading-[1.75] mb-10 max-w-xl mx-auto">
          在台中的城市角落，遇見妳的下一件命定服飾
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleExplore}
            className="whitespace-nowrap font-sans-body text-[1.0625rem] font-medium bg-white text-warm-900 px-8 py-3 rounded-full hover:bg-cream-100 transition-all duration-300 cursor-pointer"
          >
            立即探索
          </button>
          <button
            onClick={handleStore}
            className="whitespace-nowrap font-sans-body text-[1.0625rem] font-medium border border-white text-white px-8 py-3 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            查看門市
          </button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-70">
          <span className="text-white text-xs font-sans-body tracking-widest">SCROLL</span>
          <div className="w-px h-8 bg-white/60 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
